/* ============================================================
   Chiara Wonder · hero slider "Tavole" (sections/cw-home-hero-slider.liquid).
   No dependencies, delegated listeners, any number of instances.
   - Track = horizontal scroll-snap scroller: native swipe on touch, trackpad on desktop, mouse drag on desktop.
     Programmatic moves use smooth scroll (instant with prefers-reduced-motion).
   - Indicators under the slides: role group, aria-current on the active one, roving tabindex,
     ArrowLeft/Right/Home/End move and focus. Inactive slides inert + aria-hidden once the scroll settles.
   - "Tavola n di N" in a polite live region on user changes only (never on autoplay).
   - Autoplay only when the section has data-cw-hs-autoplay (seconds; setting OFF by default). Paused on hover and
     focus inside, stopped for good on touch / drag / indicator use, never with reduced motion, hidden tab,
     off-screen section or the motion button in "paused".
   - Lazy stills: [data-src]/[data-srcset] become real when a slide is approached (swipe, drag, indicator, autoplay),
     and after window load + idle ONLY for the slide next to the active one (CRO06 I-3, dev4: tavola 3, ~170 KB on
     mobile, is no longer downloaded by visitors who never move the slider). Each settle prepares the next slide.
   - Video [data-cw-hs-video]: active slide only, after load + idle, only with prefers-reduced-motion: no-preference
     and without Save-Data; WebM then MP4, desktop/mobile file by matchMedia(max-width: 599px). Fades in on `playing`.
     Pauses off-screen, on hidden tab, on slide change. Pause choice in localStorage (also stops autoplay).
   ============================================================ */
(function () {
  'use strict';
  if (window.__cwHsInit) return;
  window.__cwHsInit = true;

  var MQ_M = '(max-width: 599px)';
  var KEY = 'cw-hero-motion';
  var ready = false;
  var mm = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function reduced() { return mm('(prefers-reduced-motion: reduce)'); }
  function motionOK() { var c = navigator.connection; return !reduced() && !(c && c.saveData); }
  function paused() { try { return localStorage.getItem(KEY) === 'paused'; } catch (e) { return false; } }
  function setPaused(v) { try { if (v) localStorage.setItem(KEY, 'paused'); else localStorage.removeItem(KEY); } catch (e) { /* private mode */ } }

  function slides(root) { return $$('[data-cw-hs-slide]', root); }
  function dots(root) { return $$('[data-cw-hs-dot]', root); }
  function track(root) { return root.querySelector('[data-cw-hs-track]'); }
  function current(root) { return root.__cwI || 0; }
  function rootOf(el) { return el && el.closest ? el.closest('[data-cw-hs]') : null; }
  function hydrate(slide) {
    if (!slide) return;
    $$('[data-srcset]', slide).forEach(function (el) { el.setAttribute('srcset', el.getAttribute('data-srcset')); el.removeAttribute('data-srcset'); });
    $$('img[data-src]', slide).forEach(function (el) { el.setAttribute('src', el.getAttribute('data-src')); el.removeAttribute('data-src'); });
  }

  /* ---------- video ---------- */
  function sources(v) {
    var k = mm(MQ_M) ? 'm' : 'd';
    var list = [];
    ['webm', 'mp4'].forEach(function (t) { var u = v.getAttribute('data-src-' + k + '-' + t); if (u) list.push([u, 'video/' + t]); });
    return { k: k, list: list };
  }
  function usable(slide) {
    var v = slide && slide.querySelector('video[data-cw-hs-video]');
    return v && !v.__cwErr && sources(v).list.length ? v : null;
  }
  function attach(v) {
    var s = sources(v);
    if (v.__cwK === s.k) return;
    v.__cwK = s.k;
    v.classList.remove('is-playing');
    while (v.firstChild) v.removeChild(v.firstChild);
    var img = v.parentNode && v.parentNode.querySelector('img');
    if (img && img.currentSrc) v.setAttribute('poster', img.currentSrc);
    s.list.forEach(function (x) { var e = document.createElement('source'); e.src = x[0]; e.type = x[1]; v.appendChild(e); });
    v.load();
  }
  function autoMs(root) { var v = Number(root.getAttribute('data-cw-hs-autoplay')); return v >= 3 && slides(root).length > 1 ? v * 1000 : 0; }
  function sync(root) {
    var s = slides(root), i = current(root), btn = root.querySelector('[data-cw-hs-motion]');
    var v = motionOK() ? usable(s[i]) : null;
    var stop = paused();
    s.forEach(function (sl, k) {
      var x = sl.querySelector('video[data-cw-hs-video]');
      if (x && (k !== i || !v) && !x.paused) x.pause();
    });
    if (btn) {
      btn.hidden = !(v || (autoMs(root) && !reduced() && !root.__cwStopped));
      btn.setAttribute('aria-pressed', String(stop));
      btn.setAttribute('aria-label', stop ? 'Riprendi il movimento' : 'Metti in pausa il movimento');
    }
    timer(root);
    if (!v || !ready) return;
    if (stop || root.__cwOut || document.hidden) { if (!v.paused) v.pause(); return; }
    attach(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* autoplay refused: the still stays */ });
  }
  function syncAll() { $$('[data-cw-hs]').forEach(sync); }

  /* ---------- autoplay (opt-in) ---------- */
  function timer(root) {
    clearTimeout(root.__cwT);
    var ms = autoMs(root), now = Date.now(), cl = root.classList;
    var allowed = ms && ready && !reduced() && !paused() && !root.__cwStopped && !root.__cwOut && !document.hidden;
    if (!allowed) { cl.remove('is-timing', 'is-held'); root.__cwRem = 0; return; }
    var same = cl.contains('is-timing') && root.__cwTI === current(root) && root.__cwTE > 0;
    if (root.__cwHover || root.__cwFocus) { /* hover / focus: freeze the progress, keep the remaining time */
      if (same && !cl.contains('is-held')) { root.__cwRem = Math.max(600, root.__cwTE - now); cl.add('is-held'); }
      return;
    }
    if (same && cl.contains('is-held') && root.__cwRem) { cl.remove('is-held'); root.__cwTE = now + root.__cwRem; root.__cwRem = 0; }
    if (same && root.__cwTE > now) { root.__cwT = setTimeout(function () { advance(root); }, root.__cwTE - now); return; }
    cl.remove('is-held'); root.__cwRem = 0;
    root.__cwTI = current(root);
    root.__cwTE = now + ms;
    root.style.setProperty('--cw-hs-dur', ms + 'ms');
    cl.remove('is-timing');
    void root.offsetWidth; /* restart the progress fill */
    cl.add('is-timing');
    root.__cwT = setTimeout(function () { advance(root); }, ms);
  }
  function advance(root) { root.__cwTE = 0; go(root, current(root) + 1, {}); }
  function stopAuto(root) { if (!root.__cwStopped) { root.__cwStopped = true; sync(root); } }

  /* ---------- slides ---------- */
  function mark(root, i) {
    dots(root).forEach(function (b, k) {
      if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      b.tabIndex = k === i ? 0 : -1;
    });
  }
  function settle(root, i, announce) {
    var s = slides(root), was = current(root);
    root.__cwI = i;
    s.forEach(function (sl, k) {
      var on = k === i;
      sl.classList.toggle('is-active', on);
      if (on) { sl.removeAttribute('inert'); sl.removeAttribute('aria-hidden'); }
      else { sl.setAttribute('inert', ''); sl.setAttribute('aria-hidden', 'true'); }
    });
    mark(root, i);
    hydrate(s[i]);
    if (ready) hydrate(s[(i + 1) % s.length]);
    var ae = document.activeElement;
    if (ae && ae !== document.body && s[i] && !s[i].contains(ae) && ae.closest && ae.closest('[data-cw-hs-slide]') && root.contains(ae)) {
      var d = dots(root)[i]; if (d) d.focus({ preventScroll: true });
    }
    if (i !== was) {
      root.__cwTE = 0;
      if (announce) { var live = root.querySelector('[data-cw-hs-live]'); if (live) live.textContent = 'Tavola ' + (i + 1) + ' di ' + s.length; }
    }
    sync(root);
  }
  function width(t) { return t.clientWidth || 1; }
  function go(root, i, o) {
    o = o || {};
    var s = slides(root), n = s.length, t = track(root);
    if (!n || !t) return;
    i = ((i % n) + n) % n;
    hydrate(s[i]);
    root.__cwGoal = i;
    var left = i * width(t);
    if (Math.abs(t.scrollLeft - left) < 2) root.__cwGoal = null;
    else if (t.scrollTo) t.scrollTo({ left: left, behavior: o.instant || reduced() ? 'auto' : 'smooth' });
    else t.scrollLeft = left;
    settle(root, i, o.announce);
    if (o.focus) { var d = dots(root)[i]; if (d) d.focus({ preventScroll: true }); }
  }
  function fromScroll(root) {
    var t = track(root), n = slides(root).length;
    return Math.max(0, Math.min(n - 1, Math.round(t.scrollLeft / width(t))));
  }

  /* scroll (does not bubble: capture). Indicators follow the finger; the slide commits when the scroll settles. */
  function onSettle(root) {
    if (root.__cwDrag || root.__cwTouch) return; /* finger still down: native scroll only, decide after touchend */
    var t = track(root), w = width(t), n = slides(root).length, i = fromScroll(root);
    if (root.__cwGoal != null) { var g = root.__cwGoal; root.__cwGoal = null; if (i === g && Math.abs(t.scrollLeft - g * w) <= 2) return; } /* else the user took over */
    /* never rest between two slides (a nested snap point, discrete wheel ticks): past 15 % of a slide = go on in that
       direction, otherwise back to the current one */
    var off = t.scrollLeft - current(root) * w;
    if (Math.abs(t.scrollLeft - i * w) > 2) i = Math.abs(off) > w * 0.15 ? Math.max(0, Math.min(n - 1, current(root) + (off > 0 ? 1 : -1))) : current(root);
    if (i !== current(root)) { stopAuto(root); settle(root, i, true); }
    if (Math.abs(t.scrollLeft - i * w) > 2) { root.__cwGoal = i; t.scrollTo({ left: i * w, behavior: reduced() ? 'auto' : 'smooth' }); }
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-cw-hs-track]')) return;
    var root = rootOf(t);
    if (!root) return;
    if (!root.__cwSeen) { root.__cwSeen = true; slides(root).forEach(hydrate); }
    if (root.__cwGoal == null && !root.__cwDrag) mark(root, fromScroll(root));
    clearTimeout(root.__cwS);
    root.__cwS = setTimeout(function () { onSettle(root); }, 160);
  }, true);
  document.addEventListener('scrollend', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-cw-hs-track]')) return;
    var root = rootOf(t);
    if (root) { clearTimeout(root.__cwS); onSettle(root); }
  }, true);

  document.addEventListener('click', function (e) {
    var el = e.target, root = rootOf(el);
    if (!root) return;
    if (root.__cwDragged && Date.now() - root.__cwDragged < 400 && el.closest('[data-cw-hs-track]')) { e.preventDefault(); e.stopPropagation(); return; }
    var dot = el.closest('[data-cw-hs-dot]');
    if (dot) { stopAuto(root); go(root, dots(root).indexOf(dot), { announce: true }); return; }
    var mot = el.closest('[data-cw-hs-motion]');
    if (mot) { setPaused(!paused()); sync(root); }
  }, true);
  document.addEventListener('keydown', function (e) {
    var dot = e.target.closest && e.target.closest('[data-cw-hs-dot]');
    if (!dot) return;
    var root = rootOf(dot), list = dots(root), i = list.indexOf(dot), n = list.length, j = null;
    if (e.key === 'ArrowRight') j = i + 1;
    else if (e.key === 'ArrowLeft') j = i - 1;
    else if (e.key === 'Home') j = 0;
    else if (e.key === 'End') j = n - 1;
    if (j === null) return;
    e.preventDefault();
    stopAuto(root);
    go(root, j, { focus: true, announce: true });
  });

  /* mouse drag on desktop (touch and trackpads scroll natively). Never starts on links, buttons or form fields. */
  var drag = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var t = e.target.closest && e.target.closest('[data-cw-hs-track]');
    if (!t || e.target.closest('a, button, input, select, textarea, label')) return;
    var root = rootOf(t);
    if (!root || slides(root).length < 2) return;
    drag = { r: root, t: t, x: e.clientX, y: e.clientY, left: t.scrollLeft, id: e.pointerId, i: current(root), on: false };
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag || drag.id !== e.pointerId) return;
    var r = drag.r, t = drag.t, dx = e.clientX - drag.x;
    if (!drag.on) {
      if (Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(e.clientY - drag.y)) return;
      drag.on = true; r.__cwDrag = true;
      r.classList.add('is-dragging'); stopAuto(r);
      slides(r).forEach(hydrate);
      try { t.setPointerCapture(e.pointerId); } catch (err) { /* old browsers */ }
    }
    t.scrollLeft = drag.left - dx;
    mark(r, fromScroll(r));
  });
  function endDrag(e) {
    var d = drag;
    if (!d || d.id !== e.pointerId) return;
    drag = null;
    if (!d.on) return;
    var r = d.r, n = slides(r).length, dx = e.clientX - d.x;
    r.__cwDrag = false;
    r.classList.remove('is-dragging');
    r.__cwDragged = Date.now();
    var j = e.type === 'pointercancel' ? d.i : (Math.abs(dx) > Math.min(90, width(d.t) * 0.12) ? d.i + (dx < 0 ? 1 : -1) : d.i);
    j = Math.max(0, Math.min(n - 1, j));
    go(r, j, { announce: j !== d.i });
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  /* media events do not bubble: capture */
  document.addEventListener('playing', function (e) {
    if (e.target.matches && e.target.matches('video[data-cw-hs-video]')) e.target.classList.add('is-playing');
  }, true);
  document.addEventListener('error', function (e) {
    var t = e.target, v = t && t.parentNode;
    if (!t || t.tagName !== 'SOURCE' || !v || !v.matches || !v.matches('video[data-cw-hs-video]') || t !== v.lastElementChild) return;
    v.__cwErr = true;
    v.classList.remove('is-playing');
    var r = rootOf(v);
    if (r) sync(r);
  }, true);
  document.addEventListener('visibilitychange', syncAll);
  if (window.matchMedia) {
    [MQ_M, '(prefers-reduced-motion: reduce)'].forEach(function (q) {
      var l = window.matchMedia(q);
      if (l.addEventListener) l.addEventListener('change', syncAll); else if (l.addListener) l.addListener(syncAll);
    });
  }
  /* keep the active slide aligned when the width changes (rotation, resize) */
  var rz;
  window.addEventListener('resize', function () {
    clearTimeout(rz);
    rz = setTimeout(function () { $$('[data-cw-hs]').forEach(function (r) { var t = track(r); if (t && !r.__cwDrag) { r.__cwGoal = null; t.scrollLeft = current(r) * width(t); } }); }, 120);
  });

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { en.target.__cwOut = !en.isIntersecting; sync(en.target); });
  }, { threshold: 0.15 }) : null;

  function hold(root, k, v) { root[k] = v; timer(root); }
  function init(root) {
    if (root.__cwHs) return;
    root.__cwHs = true;
    root.__cwI = 0;
    root.classList.add('is-ready');
    if (io) io.observe(root);
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold(root, '__cwHover', true); });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hold(root, '__cwHover', false); });
    root.addEventListener('focusin', function () { hold(root, '__cwFocus', true); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) hold(root, '__cwFocus', false); });
    root.addEventListener('touchstart', function () { root.__cwTouch = true; stopAuto(root); }, { passive: true });
    var lift = function () { root.__cwTouch = false; clearTimeout(root.__cwS); root.__cwS = setTimeout(function () { onSettle(root); }, 160); };
    root.addEventListener('touchend', lift, { passive: true });
    root.addEventListener('touchcancel', lift, { passive: true });
    if (ready) near(root);
    sync(root);
  }
  $$('[data-cw-hs]').forEach(init);

  function whenIdle(fn) { if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2500 }); else setTimeout(fn, 300); }
  function near(r) { var s = slides(r), i = current(r); hydrate(s[i]); if (s.length > 1) hydrate(s[(i + 1) % s.length]); }
  function onLoad() {
    whenIdle(function () {
      ready = true;
      $$('[data-cw-hs]').forEach(function (r) { near(r); sync(r); });
    });
  }
  if (document.readyState === 'complete') onLoad(); else window.addEventListener('load', onLoad);

  /* theme editor: new section instances and block selection */
  document.addEventListener('shopify:section:load', function (e) { $$('[data-cw-hs]', e.target).forEach(init); });
  document.addEventListener('shopify:block:select', function (e) {
    var sl = e.target.closest && e.target.closest('[data-cw-hs-slide]');
    var root = rootOf(sl);
    if (root) { stopAuto(root); go(root, slides(root).indexOf(sl), { instant: true }); }
  });
})();
